import styled from '@emotion/styled'
import theme from '@utils/theme'

export const StyleGroupCheckboxItems = styled.div`
  width: 80%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
`

export const StyleGroupCheckboxItem = styled.div<any>`
  display: flex;
  align-items: center;

  ${(props: any) => props.styleItem}
`

export const StyleCheckbox = styled.input`
  width: 16px;
  height: 16px;
`

export const StyleCheckboxLabel = styled.p`
  font-size: 14px;

  color: ${theme.colors.text};
`
